module.exports = __webpack_public_path__ + "media/images/photo17-ddf0a967fa08d5d35c4cadb284764c17.png";